<template>
  <info-dialog v-model="isActive" :title="prodotto.name" :max-width="image ? '750px' : '500px'">

    <!-- Titolo -->
    <div slot="title">
      <span class="mr-2 left line-height-24">{{  prodotto.name }}</span>

      <v-tooltip class="left" bottom v-if="prodotto.attivo === false">
        <alert-chip slot="activator" color="error">
          {{ $t('prodotti.label.dismesso') }}
          <v-icon small class="ml-1" color="white">help_outline</v-icon>
        </alert-chip>
        <span class="text-pre-line">{{ $t('prodotti.label.dismesso_info') }}</span>
      </v-tooltip>
    </div>

    <!-- Immagine -->
    <v-flex xs4 v-if="image">
      <v-img contain :src="image" height="200px" aspect-ratio="1">
        <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
          <v-progress-circular indeterminate color="primary"/>
        </v-layout>
      </v-img>
    </v-flex>

    <v-flex :xs8="!!image" :xs12="!image" class="pl-3 line-height-24">

      <!-- Bottone ripristina -->
      <div v-if="showRipristina && prodotto.attivo === false" class="clear-both">
        <v-btn small class="mx-0" color="error" :loading="sendingRipristina" @click="ripristinaProdotto">
          {{$t('magazzino.azioni.riabilita_prodotto') }}
        </v-btn>
      </div>

      <!-- Sku -->
      <div v-if="prodotto.sku" class="clear-both">
        <span>{{ $t('prodotti.label.sku') }}: </span><b>{{ prodotto.sku }}</b>
      </div>

      <!-- Modifica quantità -->
      <div v-if="(showEditQuantitaMagazzino || showEditQuantitaUnitaMobile) && prodotto.attivo !== false && prodotto.quantita >= 0">
        <span class="left">
          {{ showEditQuantitaMagazzino ?  $t('prodotti.label.quantita_magazzino')  : $t('prodotti.label.quantita_unita_mobile')}}:
        </span>
        <number-input v-model.number="quantita" :max="prodotto.quantitaMax" :min="showEditQuantitaMagazzino ? 0 : 1" class="left"/>
      </div>

      <!-- Prezzo consigliato -->
      <div v-if="showEditQuantitaMagazzino && prodotto.attivo !== false && prodotto.price" class="clear-both">
        <span>{{ $t('prodotti.label.prezzo_acquisto') }}: </span>
        <b>{{ prodotto.price }}€</b>
      </div>

      <!-- Prezzo assegnato -->
      <div v-if="(!showEditQuantitaMagazzino || prodotto.attivo === false) && prodotto.price_costumer">
        <span>{{ $t('prodotti.label.prezzo_assegnato') }}: </span>
        <b>{{ prodotto.price_costumer }}€</b>
      </div>

      <!-- Modifica prezzo "price_customer" -->
      <div v-if="showEditQuantitaMagazzino && prodotto.attivo !== false">
        <span class="left">{{ $t('prodotti.label.prezzo_assegnato') }}: </span>
        <number-input v-model.number="priceCostumer" :min="0" type="price" suffix="€" hide-buttons class="left"/>
      </div>

      <div v-if="(showEditQuantitaMagazzino || showEditQuantitaUnitaMobile) && prodotto.attivo !== false" class="clear-both">
        <v-btn small class="accent ma-0" :loading="sendingQuantita" @click="modificaDati">
          {{ $t('azioni.salva') }}
        </v-btn>
      </div>

      <!-- Descrizione -->
      <div v-if="prodotto.description" class="mt-3">
        <span v-html="prodotto.description"></span>
      </div>
      <div v-if="prodotto.permalink">
        <a :href="prodotto.permalink" target="_blank" class="accent--text">
          {{ $t('prodotti.label.dettagli') }}
        </a>
      </div>
    </v-flex>

  </info-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import InfoDialog from '@/components/base/InfoDialog'
import NumberInput from '@/components/inputs/NumberInput'

export default {
    name: 'ProductDialog',
    mixins: [Toggleable],
    components: { NumberInput, InfoDialog },
    props: {
        showEditQuantitaMagazzino: Boolean,
        showEditQuantitaUnitaMobile: Boolean,
        showRipristina: Boolean
    },
    data: () => ({
        prodotto: {},
        priceCostumer: 0,
        quantita: 0,
        quantitaOld: 0,
        sendingRipristina: false,
        sendingQuantita: false
    }),
    methods: {
        show (prodotto) {
            this.prodotto = prodotto
            this.priceCostumer = prodotto.price_costumer
            this.quantita = prodotto.quantita
            //  Usata nell'unità mobile per calcolare la differenza di prodotti
            this.quantitaOld = prodotto.quantita
            this.isActive = true
            this.sendingRipristina = false
            this.sendingQuantita = false
        },
        ripristinaProdotto () {
            this.sendingRipristina = true
            this.$api.magazzino.restoreDismesso(this.prodotto).then(response => {
                this.$snackbar.show(this.$t('magazzino.messaggi.prodotto_riabilitato'), 'success')
                this.sendingRipristina = false
                this.isActive = false
                this.$emit('re-enabled')
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.sendingRipristina = false
            })
        },
        modificaDatiAction () {
            if (this.showEditQuantitaMagazzino) {
                return this.$api.magazzino.editQuantitaPrezzo(this.prodotto, this.quantita, this.priceCostumer)
            } else {
                return this.$api.unitaMobili.editQuantitaProdotto(this.prodotto.targa, this.prodotto, this.quantita - this.quantitaOld)
            }
        },
        modificaDati () {
            this.sendingQuantita = true
            this.modificaDatiAction().then(response => {
                if (this.showEditQuantitaMagazzino) {
                    this.$snackbar.show(this.$t('magazzino.messaggi.dati_prodotto_modificati'), 'success')
                } else {
                    this.$snackbar.show(this.$t('unita_mobili.messaggi.quantita_modificata'), 'success')
                }
                this.sendingQuantita = false
                this.isActive = false
                this.$emit('quantita-changed')
            }).catch(e => {
                this.$snackbar.showServerError(e)
                this.sendingQuantita = false
            })
        }
    },
    computed: {
        image () {
            return this.prodotto.src || (this.prodotto.images && this.prodotto.images[0].src)
        }
    }
}
</script>
